import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import BananatagButton from '../../../../../componentLibrary/BananatagButton';
import Modal from '../../../../../componentLibrary/Modal';
import handleKeyPress from '../../../../../common/handleKeyPress';
import * as Styled from './styles';

const MODAL_HEIGHT = 304;
const MODAL_WIDTH = 394;

const DeleteModal = ({ modalText, toggleDeleteModal, onDelete }) => {
    const closeModalButton = useRef(null);

    useEffect(() => {
        if (closeModalButton && closeModalButton.current) {
            closeModalButton.current.focus();
        }
    }, []);

    return (
        <Modal width={MODAL_WIDTH} height={MODAL_HEIGHT} onEsc={toggleDeleteModal}>
            <Styled.CloseButtonWrapper
                onClick={toggleDeleteModal}
                onKeyDown={(e) => handleKeyPress(e, toggleDeleteModal)}
                role="button"
                tabIndex="0"
                aria-label="close modal"
                ref={closeModalButton}
            >
                <Styled.CloseIcon icon="times" aria-hidden />
            </Styled.CloseButtonWrapper>
            <Styled.ModalHeader>Confirm Deletion</Styled.ModalHeader>
            <Styled.DeleteWarning> This action cannot be undone.</Styled.DeleteWarning>
            <Styled.ModalText>{modalText}</Styled.ModalText>
            <Styled.DeleteModalButtons>
                <BananatagButton
                    type="clear"
                    size="large"
                    onClick={toggleDeleteModal}
                    text="cancel"
                    styling={{ marginRight: 10 }}
                />
                <BananatagButton type="warning" size="large" onClick={onDelete} text="Delete" />
            </Styled.DeleteModalButtons>
        </Modal>
    );
};

DeleteModal.propTypes = {
    toggleDeleteModal: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    modalText: PropTypes.string.isRequired,
};

export default DeleteModal;
